enum ListingType {
    EVENT = "EVENT",
    PARKING = "PARKING"
}

export default ListingType;